<script lang="ts">
  // component
  import BannerBase from "@retailer/svelte/Payments/Banners/Base.svelte";

  // props
  export let handleNotificationPayBannerEnabled: (type: string) => void;
  export let handleBannerClose: (type: string) => void;

  // data
  const notificationPayBannerType = "notification_pay_banner";

</script>

<div class="fizz-flex-item fizz-inset-square-16" data-testid={notificationPayBannerType}>
  <BannerBase
    iconType={"Statement"}
    heading="New! Pay invoices on Provi. Sign up to get notified when you have outstanding invoices."
    onClose={() => handleBannerClose(notificationPayBannerType)}
  >
    <p class="fizz-text-medium">
      Update your notification settings so that we can email you the next time you have an
      outstanding invoice. Outstanding invoices can be paid quickly using ACH or credit card,
      eliminating the need for checks.
    </p>
    <br />
    <button
      on:click|preventDefault={() => handleNotificationPayBannerEnabled(notificationPayBannerType)}
      class="fizz-button fizz-button-small">Turn on invoice notifications</button
    >
  </BannerBase>
</div>
